export default __webpack_public_path__ + "static/media/green-arrow.d84eb0bd.svg";